/**
 * TanStack Query hooks for `reddit-conversions-api`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	redditConversionsApiQueryKeys,
	type CreateRedditConversionsApiBody,
	type ListRedditConversionsApiResponse,
	type RedditConversionsApiRow,
} from "./api";

export function useRedditConversionsApiList(): UseQueryResult<ListRedditConversionsApiResponse, Error> {
	return useQuery({
		queryKey: redditConversionsApiQueryKeys.list(),
		queryFn: list,
	});
}

export function useRedditConversionsApiCreate(): UseMutationResult<RedditConversionsApiRow, Error, CreateRedditConversionsApiBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: redditConversionsApiQueryKeys.all });
		},
	});
}

export function useRedditConversionsApiDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: redditConversionsApiQueryKeys.all });
		},
	});
}
